import CompareEKG from './CompareEKG'

export default CompareEKG



// WEBPACK FOOTER //
// ./src/legacy/containers/EkgRecordingReviewScreen/components/CompareEKG/index.js